if (!customElements.get("product-min-bundle")) {
  class MProductMinBundle extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        bundlesItem: ".product-bundles__item",
        regularPrice:"[data-regular-price]",
        salePrice:"[data-sale-price]",
        crossedPrice:"[data-crossed-price]",
        saleInfo:"[data-sale-info]",
        saveInfo:"[data-save-info]",
        bundleId:"[name='bundleId']",
        saleCount:"[data-sale-count]",
        saleDiscount:"[data-sale-discount]",
        saveTotal:"[data-save-total]",
        productVariantSelects: ".product-option--dropdown-select",
        productBundlesCheck: ".product-bundles__check"
      };
    }

    connectedCallback() {
      this.initProductBundles();
    }

    initProductBundles(){
      const bundleProduct = this.querySelectorAll(this.selectors.bundlesItem);
      const saleCount = parseInt(this.getAttribute('data-count'));
      
      bundleProduct.forEach(item => {
        let variants = item.nextElementSibling;
        variants = JSON.parse(variants.innerHTML);

        addEventDelegate({
          context: item,
          event: "change",
          selector: this.selectors.productVariantSelects,
          handler: (e) => {this.changePrice(e, item, variants, saleCount, bundleProduct);
            this.changeImage(e, item, variants)
          },
        });

        addEventDelegate({
          context: item,
          event: "click",
          selector: this.selectors.productBundlesCheck,
          handler: () => this.updatePrices(saleCount, bundleProduct),
        });
      });
      this.updatePrices(saleCount, bundleProduct);
    }

    updatePrices(saleCount, bundleProduct) {
      if (!saleCount) return;
      const selectedCount = this.querySelectorAll(`${this.selectors.bundleId}:checked`).length;
      
      const saleInfo = this.querySelector(this.selectors.saleInfo);
      const saveInfo = this.querySelector(this.selectors.saveInfo);
      const datasaleDiscount = this.querySelector(this.selectors.saleDiscount);
      const datasaleCount = this.querySelector(this.selectors.saleCount);
      const saveTotal = this.querySelector(this.selectors.saveTotal);
      
      if (selectedCount >= saleCount) {
        if (saleInfo) saleInfo.classList.add('hidden');
        if (saveInfo) {
          saveInfo.classList.remove('hidden');
          let totalSavings = 0;
          bundleProduct.forEach( item => {
            const bundleId = item.querySelector(this.selectors.bundleId);
            if ( bundleId && bundleId.checked ) {
              const regularPrice = item.querySelector(this.selectors.regularPrice);
              const salePrice = item.querySelector(this.selectors.salePrice);
              if ( regularPrice && salePrice ) {
                const regularPriceValue = parseFloat(regularPrice.getAttribute('data-regular-price'));
                const salePriceValue = parseFloat(salePrice.getAttribute('data-sale-price'));
                totalSavings += (regularPriceValue - salePriceValue) / 100;
              }
            }
          });
          saveTotal.textContent = totalSavings.toFixed(2);
        }
      } else {
        if (saleInfo) {
          saleInfo.classList.remove('hidden');
          const remaining = saleCount - selectedCount;
          const saleDiscount = parseInt(this.getAttribute('data-discount'));
          datasaleCount.textContent = remaining;
          datasaleDiscount.textContent = saleDiscount
        }
        if (saveInfo) saveInfo.classList.add('hidden');
      }
      
      bundleProduct.forEach(item => {
        const bundleId = item.querySelector(this.selectors.bundleId);
        if (!bundleId) return;
        
        const regularPrice = item.querySelector(this.selectors.regularPrice);
        const salePrice = item.querySelector(this.selectors.salePrice);
        const crossedPrice = item.querySelector(this.selectors.crossedPrice);
        
        if (selectedCount >= saleCount) {
          if (regularPrice) regularPrice.classList.add('hidden');
          if (salePrice) salePrice.classList.remove('hidden');
          if (crossedPrice) crossedPrice.classList.remove('hidden');
        } else {
          if (regularPrice) regularPrice.classList.remove('hidden');
          if (salePrice) salePrice.classList.add('hidden');
          if (crossedPrice) crossedPrice.classList.add('hidden');
        }
      });
    }

    changePrice(evt, product, variants, saleCount, productBundles) {
      const regularPrice = product.querySelector(this.selectors.regularPrice);
      const salePrice = product.querySelector(this.selectors.salePrice);
      const crossedPrice = product.querySelector(this.selectors.crossedPrice);
      const selectedVariant = evt.target.value;
      const variant = variants.find((v) => v.id === parseInt(selectedVariant));

      if (regularPrice) {
        regularPrice.innerHTML = formatMoney(variant.price, ThemeSettings.money_format)
        regularPrice.setAttribute('data-regular-price', variant.price);
      };
      if (salePrice) {
        salePrice.innerHTML = formatMoney(variant.sale_price, ThemeSettings.money_format);
        salePrice.setAttribute('data-sale-price', variant.sale_price);
      };
      if (crossedPrice) {
        crossedPrice.innerHTML = formatMoney(variant.price, ThemeSettings.money_format);
        crossedPrice.setAttribute('data-crossed-price', variant.price);
      };
      this.updatePrices(saleCount, productBundles);
    }

    changeImage(evt, item, variants){
      const selectedVariant = evt.target.value;
      const variant = variants.find((v) => v.id === parseInt(selectedVariant));
      const src = variant && variant.featured_image.src;
      const img = item.querySelector("img");

      if (img && src) {
        img.src = `${src}&width=160`;
        img.removeAttribute("srcset");
      }
    }

  }
  customElements.define("product-min-bundle", MProductMinBundle);
}
